import React from 'react';
import { Check, Loader, AlertCircle, Cloud } from 'lucide-react';
import { SaveStatus } from '../hooks/useAutosave';

interface SaveStatusIndicatorProps {
  status: SaveStatus;
}

export const SaveStatusIndicator: React.FC<SaveStatusIndicatorProps> = ({ status }) => {
  switch (status) {
    case 'saving':
      return (
        <div className="flex items-center gap-1.5 text-xs text-gray-500">
          <Loader className="h-3.5 w-3.5 animate-spin" />
          <span>Saving...</span>
        </div>
      );
    case 'saved':
      return (
        <div className="flex items-center gap-1.5 text-xs text-green-600">
          <Check className="h-3.5 w-3.5" />
          <span>All changes saved</span>
        </div>
      );
    case 'error':
      return (
        <div className="flex items-center gap-1.5 text-xs text-red-600">
          <AlertCircle className="h-3.5 w-3.5" />
          <span>Save failed</span>
        </div>
      );
    default:
      return (
        <div className="flex items-center gap-1.5 text-xs text-gray-400">
          <Cloud className="h-3.5 w-3.5" />
          <span>Saved</span>
        </div>
      );
  }
};
